export const deepMerge = (target: any, source: any): any => {
  if (!target || typeof target !== 'object') return source;
  if (!source || typeof source !== 'object') return target;

  return Object.keys(source).reduce(
    (acc, key) => {
      const targetValue = target[key];
      const sourceValue = source[key];

      acc[key] =
        sourceValue &&
        typeof sourceValue === 'object' &&
        !Array.isArray(sourceValue)
          ? deepMerge(targetValue ?? {}, sourceValue)
          : sourceValue;
      return acc;
    },
    { ...target }
  );
};
